import { render, staticRenderFns } from "./NyugtaModal.vue?vue&type=template&id=6bee876a"
import script from "./NyugtaModal.vue?vue&type=script&lang=js"
export * from "./NyugtaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports